import React, { Component } from "react";
import { AxiosResponse } from "axios";
import { errorNotification } from "../../../../utils/helpers";
import { getRequest } from "../../../../utils/httpRequest";
import { Carousel } from "../../../common";
import { BlogResource } from "../../../../stores/BlogStore/Types";
import BlogPost from "./BlogPost";

interface State {
  blogPosts: BlogResource;
  loading: boolean;
}

class Blog extends Component<{}, State> {
  constructor(props) {
    super(props);

    this.state = {
      blogPosts: [],
      loading: true,
    };
  }

  componentDidMount() {
    return getRequest("/api/blogs.json")
      .then((response: AxiosResponse) => {
        this.setState({
          blogPosts: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });

        errorNotification(
          "Error loading data",
          JSON.stringify(error?.response?.data),
        );
      });
  }

  scrollCarousel = (gridId, cardSelector, direction) => {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    const card = grid.querySelector(cardSelector);
    if (!card) return;
    const scrollAmount = (card.offsetWidth + 20) * direction;
    grid.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  scrollBlog = (direction: number) => {
    this.scrollCarousel("blogGrid", ".blog-card", direction);
  };

  render() {
    const { blogPosts } = this.state;

    return (
      <section className="blog-section" aria-labelledby="blog-title">
        <div className="container">
          <div className="header">
            <span className="eyebrow">Our Blog</span>

            <h2 id="blog-title">
              Weird and wonderful <em>things we've written about</em>
            </h2>

            <p className="blog-sub">
              Behavioural science, creativity, lateral thinking and the
              occasional rubber duck. Mostly the rubber duck.
            </p>
          </div>
        </div>

        <div className="blog-carousel">
          <button
            className="blog-nav prev"
            type="button"
            onClick={() => this.scrollBlog(-1)}
            aria-label="Previous blog posts"
          >
            &lsaquo;
          </button>

          <div className="blog-grid" id="blogGrid" role="list">
            {(blogPosts || []).map((post, i) => (
              <BlogPost post={post} idx={i} key={post.guid} />
            ))}
          </div>

          <button
            className="blog-nav next"
            type="button"
            onClick={() => this.scrollBlog(1)}
            aria-label="Next blog posts"
          >
            &rsaquo;
          </button>
        </div>

        <div className="container">
          <div className="view-all">
            <a href="/blog">Read all posts on the blog</a>
          </div>
        </div>
      </section>
    );
  }
}

export default Blog;
